import React from "react";
import Sidebar from "../Sidebar";
import Header from "../Header/Header";

const Layout = ({ children }) => {
  return (
    <div className="flex h-screen">
      {/* Sidebar con altura fija de pantalla y sin scroll */}
      <Sidebar />

      <div className="flex-grow h-screen flex flex-col">
        <Header />

        <div className="bg-[#c8d9d663] dark:bg-[#1d1d1d]  flex-grow overflow-auto">
          {children}
        </div>
      </div>
    </div>
  );
};
export default Layout;
